import React, {Component} from 'react';
import MdPerson from 'react-icons/lib/md/person';
import {connect} from 'react-redux';
import {Link} from "react-router-dom";
import './styles.css';
import {RaisedButton, Loader} from '../../components';
import {switchApplyPopup} from '../../actions';


class Header extends Component {
  dropMenuOpen() {
    if (this.dropRef.offsetHeight === 0) {
      this.dropRef.style['height'] = (this.dropRef.scrollHeight) + "px";
    } else {
      this.dropRef.style['height'] = "0px";
    }
  }

  render() {
    let dropDownClasses = ['drop-down-container'];
    if (this.props.pathname.indexOf('location') !== -1) {
      dropDownClasses.push('active');
    }
    return (<header>
      <div className="header-top">
        <div>
          <div className="left">adidas Hackathons 2018</div>
          <a href="https://dashboard.adidas-hack.com/login" className="login-info">
            <span className="link-login">login</span>
            <span className="link-login-ico"><MdPerson color="#ffffff"/></span>
          </a>
        </div>
      </div>
      <div className="header-main">
        <div>
          <Link to='/' className="header-logo"><img src="/img/logo.png" alt="adidas"/></Link>
        </div>
        <div className="header-navigation">
          <Link to='/' className={`${this.props.pathname === '/' ? 'active' : ''}`}>
            <span>Overview</span>
          </Link>
          <div className={dropDownClasses.join(' ')}>
            <span onClick={this.dropMenuOpen.bind(this)}>Location</span>
            <div className="drop-down-elements" ref={(dropRef) => {
                this.dropRef = dropRef;
              }}>
              {
                this.props.events.map((e, key) => {
                  return (
                    <Link className={`${this.props.pathname === ('/location/'+e.location) ? 'active' : ''}`} key={key} onClick={this.dropMenuOpen.bind(this)} to={`/location/${e.location}`}>
                      <span>{e.location}</span>
                    </Link>
                  );
                })
              }
            </div>
          </div>
          <Link className={`${this.props.pathname === '/faq' ? 'active' : ''}`} to='/faq'>
            <span>FAQ</span>
          </Link>
        </div>
        <div><RaisedButton text="Join now" onClick={() => {
        this.props.dispatch(switchApplyPopup(true));
      }}/></div>
      </div>
    </header>);
  }
}

let mapStateToProps = (state) => {
  return {
    events: state.challenges.data,
    showModal: state.apply.showPopup,
    showLoader: state.details.loading,
    pathname: state.routerReducer.location.pathname
  }
}

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js